import React from 'react';
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

const spinnerStyle = {
    position: 'absolute', left: '50%', top: '50%',
    transform: 'translate(-50%, -50%)'
};

const Spinner = () => (
    <div style={spinnerStyle}>
        <Loader
            type="TailSpin"
            color="#7178B2"
            height={100}
            width={100}
            timeout={-1}
        />
    </div>
);

export default Spinner;
